import { render, staticRenderFns } from "./InputsRiskQuotator.vue?vue&type=template&id=71b645be&scoped=true&"
import script from "./InputsRiskQuotator.vue?vue&type=script&lang=js&"
export * from "./InputsRiskQuotator.vue?vue&type=script&lang=js&"
import style0 from "./InputsRiskQuotator.vue?vue&type=style&index=0&id=71b645be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b645be",
  null
  
)

export default component.exports